import React from 'react'
//import PropTypes from 'prop-types'


const Glyphicons = function (prop) {
  let cn = 'glyphicon glyphicon-' + prop
  return (<span className={cn} aria-hidden="true"></span>)
}

export default Glyphicons



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Glyphicons.js